
import React, { lazy, Suspense, useState } from 'react';
import { useSelector } from 'react-redux';
import { FindFirstChild, FindParrent, FindSecondChild } from '../../utils/FindMenuOption';
import { isChildWindow } from '../../utils/Constants';
import Loader from '../shared/Loader/Loader';
import TaskTopLeftContent from '../Home/TaskManagement/TaskLayout/TaskTopLeftContent';
import AIPrompts from '../Utilities/AIPrompts/AIPrompts';

// Lazy load components
const Patient = lazy(() => import('../Patient/Patient'));
const EncounterMenu = lazy(() => import('../Encounter Menu/EncounterMenu'));
const Caregiver = lazy(() => import('../Caregiver/Caregiver'));
const Setup = lazy(() => import('../Setup/Setup'));
const Monitoring = lazy(() => import('../Utilities/Monitoring/Monitoring'));
const DataImport = lazy(() => import('../Utilities/DataImport/DataImport'));
const Dashboard = lazy(() => import('../Dashboard/Dashboard'));
const Scheduler = lazy(() => import('../Scheduler/Scheduler'));
const Claims = lazy(() => import('../Billing/Claims/Claims'));
const Submission = lazy(() => import('../Billing/Submission/Submission'));
const EDIReports = lazy(() => import('../Billing/EDI Reports/EDIReports'));
const Payments = lazy(() => import('../Billing/Payments/Payments'));
const Realtime = lazy(() => import('../Billing/Realtime/Realtime'));
const Statements = lazy(() => import('../Billing/Statements/Statements '));
const AccountReceivable = lazy(() => import('../Billing/AccountReceivables/AccountReceivable'));
const Report = lazy(() => import('../Reports/Report'));
const SwitchPractice = lazy(() => import('../Settings/Switch Practice/SwitchPractice'));
const MyProfile = lazy(() => import('../Settings/My Profile/MyProfile'));
const TaskManagement = lazy(() => import('../Home/TaskManagement/TaskManagement'));
const BillingDocument = lazy(() => import('../Billing/BillingDocument/BillingDocument'));
const Support = lazy(() => import('../Support/Support'));
const BillingItems = lazy(() => import('../BillingItems/BillingItems'));
const MessageScreen = lazy(() => import('../ChatBot/MessageScreen'));
const RuleEngine = lazy(() => import('../Setup/RulesEngine/RulesEngine'));
let isHomeCareCheck
let IsMonitoringUser
const isLive = process.env.REACT_APP_ISLIVE
const MenuItemsList = () => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let isHomecareOrADC = useSelector(state => ["Adult Day Care", "Homecare Agency"].includes(state.GeneralDropDownsReducer.PracticeType))
    isHomeCareCheck = DropDowns.IsHomeCare
    IsMonitoringUser = DropDowns.IsMonitoringUser
    return [
        ...(isChildWindow ?
            [{
                name: 'Home',
                key: 1,
                icon: 'bi bi-house-fill text-white fs-16',
                component: '',
                right: FindParrent('Home')?.ISView,
                time: new Date(),
                subComponents: HomeMenuList(),
            },
            {
                name: 'Patient',
                key: 2,
                icon: 'icon-PATIENTT text-white fs-16',
                component: <Suspense fallback={<Loader />}><Patient /></Suspense>,
                right: FindParrent('Patient')?.ISView,
                time: new Date(),
            },
            ...(!isHomecareOrADC ? [
                {
                    name: 'Encounters',
                    key: 9,
                    icon: 'icon-encounter-menu text-white fs-14',
                    component: <Suspense fallback={<Loader />}><EncounterMenu /></Suspense>,
                    right: FindParrent('Encounter')?.ISView,
                    right: true,
                    time: new Date(),
                }] : []),
            {
                name: 'Billing',
                key: 6,
                icon: 'icon-BILLING text-white fs-16 ',
                component: '',
                right: FindParrent('Billing')?.ISView,
                time: new Date(),
                subComponents: BillingMenuList(),
            },
            {
                name: 'Reports',
                key: 4,
                icon: 'icon-REPORTS text-white fs-16',
                component: <Suspense fallback={<Loader />}><Report /></Suspense>,
                right: FindParrent('Reports')?.ISView,
                time: new Date(),
            },] :
            [
                {
                    name: 'Home',
                    key: 1,
                    icon: 'bi bi-house-fill text-white fs-16',
                    component: '',
                    right: FindParrent('Home')?.ISView,
                    time: new Date(),
                    subComponents: HomeMenuList(),
                },
                ...(isHomeCareCheck === 'true' ? [] :
                    [{
                        name: 'Scheduler',
                        key: 3,
                        icon: 'icon-SCHEDULER text-white fs-16',
                        component: <Suspense fallback={<Loader />}><Scheduler /></Suspense>,
                        right: FindFirstChild('Scheduler', 'Appointment')?.ISView,
                        time: new Date(),
                    }]
                ),
                {
                    name: 'Patient',
                    key: 2,
                    icon: 'icon-PATIENTT text-white fs-16',
                    component: <Suspense fallback={<Loader />}><Patient /></Suspense>,
                    right: FindParrent('Patient')?.ISView,
                    time: new Date(),
                },
                ...(isHomeCareCheck === 'true' ? [
                    {
                        name: 'Caregiver',
                        key: 1001,
                        icon: 'icon-caregiver-1 text-white fs-14',
                        component: <Suspense fallback={<Loader />}><Caregiver /></Suspense>,
                        // component:  'Caregiver',
                        right: FindFirstChild('CareGiver', 'Caregivers')?.ISView,
                        time: new Date(),
                    }
                ] : []),
                ...(!isHomecareOrADC ? [
                    {
                        name: 'Encounters',
                        key: 9,
                        icon: 'icon-encounter-menu text-white fs-14',
                        component: <Suspense fallback={<Loader />}><EncounterMenu /></Suspense>,
                        right: FindParrent('Encounter')?.ISView,
                        time: new Date(),
                    }] : []),
                {
                    name: 'Billing',
                    key: 6,
                    icon: 'icon-BILLING text-white fs-16 ',
                    component: '',
                    right: FindParrent('Billing')?.ISView,
                    time: new Date(),
                    subComponents: BillingMenuList(),
                },
                {
                    name: 'Reports',
                    key: 4,
                    icon: 'icon-REPORTS text-white fs-16',
                    component: <Suspense fallback={<Loader />}><Report /></Suspense>,
                    right: FindParrent('Reports')?.ISView,
                    time: new Date(),
                },
                {
                    name: 'Setup',
                    key: 5,
                    icon: 'icon-SETUP text-white fs-16',
                    component: <Suspense fallback={<Loader />}><Setup /></Suspense>,
                    right: FindParrent('Setup')?.ISView,
                    time: new Date(),
                    // subComponents: [{}]
                },
                {
                    name: 'Utilities',
                    key: 12,
                    icon: 'icon-UTILITIES text-white fs-16',
                    component: '',
                    right: FindParrent('Utilities')?.ISView,
                    time: new Date(),
                    subComponents: UtilitiesMenuList(),
                },
                {
                    name: 'Support',
                    key: 15,
                    icon: 'icon-SUPPORT text-white fs-16',
                    component: <Suspense fallback={<Loader />}><Support /></Suspense>,
                    right: FindParrent('Support')?.ISView,
                    time: new Date(),
                },])
    ]
}

export default MenuItemsList
export const BillingMenuList = () => [
    ...(isChildWindow ?
        [{
            name: 'Claims',
            key: 71,
            icon: 'bi bi-clipboard2-minus-fill text-white',
            component: <Suspense fallback={<Loader />}><Claims /></Suspense>,
            right: FindFirstChild('Billing', 'Claims')?.ISView,
            time: new Date(),
            // Background: { background: "#3498DB" },
        }, {
            name: 'Payments',
            key: 73,
            icon: 'bi bi-currency-dollar text-white',
            component: <Suspense fallback={<Loader />}><Payments /></Suspense>,
            right: FindFirstChild('Billing', 'Payments')?.ISView,
            time: new Date(),
            // Background: { background: "#27AE60" },
        }] :
        [{
            name: 'Claims',
            key: 71,
            icon: 'bi bi-clipboard2-minus-fill text-white',
            component: <Suspense fallback={<Loader />}><Claims /></Suspense>,
            right: FindFirstChild('Billing', 'Claims')?.ISView,
            time: new Date(),
            // Background: { background: "#3498DB" },
        },
        {
            name: 'Submission',
            key: 72,
            icon: 'bi bi-file-earmark-check-fill text-white',
            component: <Suspense fallback={<Loader />}><Submission /></Suspense>,
            right: FindFirstChild('Billing', 'Submission')?.ISView,
            time: new Date(),
            // Background: { background: "#FF5252" },
        },
        {
            name: 'EDI Reports',
            key: 78,
            icon: 'bi bi-file-earmark-check-fill text-white',
            component: <Suspense fallback={<Loader />}><EDIReports /></Suspense>,
            right: FindFirstChild('Billing', 'EDI Reports')?.ISView,
            time: new Date(),
            // Background: { background: "#FF5252" },
        }, {
            name: 'Payments',
            key: 73,
            icon: 'bi bi-currency-dollar text-white',
            component: <Suspense fallback={<Loader />}><Payments /></Suspense>,
            right: FindFirstChild('Billing', 'Payments')?.ISView,
            time: new Date(),
            // Background: { background: "#27AE60" },
        }, {
            name: 'Realtime',
            key: 74,
            icon: 'icon-REALTIME text-white',
            component: <Suspense fallback={<Loader />}><Realtime /></Suspense>,
            right: FindFirstChild('Billing', 'Real Time')?.ISView,
            time: new Date(),
            // Background: { background: "var(--orange)" },
        }, {
            name: 'Account Receivables',
            key: 75,
            icon: 'bi bi-file-earmark-medical-fill text-white',
            component: <Suspense fallback={<Loader />}><AccountReceivable /></Suspense>,
            right: FindFirstChild('Billing', 'Account Receivables')?.ISView,
            time: new Date(),
            // Background: { background: "#9B59B6" },
        },
        ...(isHomeCareCheck === 'true' ? [] : [
            {
                name: 'Statements',
                key: 76,
                icon: 'icon-STATEMENTS text-white',
                component: <Suspense fallback={<Loader />}><Statements /></Suspense>,
                right: FindFirstChild('Billing', 'Statements')?.ISView,
                time: new Date(),
                // Background: { background: "#53F8FF" },
            }]),
        {
            name: 'Document',
            key: 77,
            icon: 'icon-DOCUMENTS text-white',
            component: <Suspense fallback={<Loader />}><BillingDocument /></Suspense>,
            right: FindFirstChild('Billing', 'Document')?.ISView,
            time: new Date(),
            // Background: { background: "#53F8FF" },
        },

        ...(isHomeCareCheck === 'true' ? [] : [
            {
                name: 'Rules Engine',
                key: 79,
                icon: 'icon-STATEMENTS text-white',
                component: <Suspense fallback={<Loader />}><RuleEngine RuleEngieneHeader={true} /></Suspense>,
                right: FindSecondChild('Billing', 'Rules Engine', 'Rules Engine')?.ISView,
                // right: true,
                time: new Date(),
                // Background: { background: "#53F8FF" },
            }]),

        ])

]

export const SettingsMenu = () => [
    ...(isChildWindow ? [] :
        [{
            name: 'My Profile',
            key: 111,
            icon: 'bi bi-person-fill',
            component: <Suspense fallback={<Loader />}><MyProfile /></Suspense>,
            right: true,
            time: new Date(),
        },
        {
            name: 'Switch Practice',
            key: 10,
            icon: 'bi bi-arrow-left-right',
            component: <Suspense fallback={<Loader />}><SwitchPractice /></Suspense>,
            right: true,
            time: new Date(),
        },])
];

export const UtilitiesMenuList = () => [
    ...(isChildWindow ? [] :
        [{
            name: 'Data Import',
            key: 81,
            // icon: <img src={dataimprt} alt={"task"+ "icon"} />,
            icon: 'icon-DATA-IMPORT text-white',
            component: <Suspense fallback={<Loader />}><DataImport /></Suspense>,
            right: FindFirstChild('Utilities', 'Data Import ')?.ISView,
            time: new Date(),
        },
        {
            name: 'Monitoring',
            key: 82,
            // icon: <img src={monitor} alt={"task"+ "icon"} />,
            icon: 'icon-MONITORING text-white',
            component: <Suspense fallback={<Loader />}><Monitoring /></Suspense>,
            right: IsMonitoringUser === 'true' ? true : false,
            time: new Date(),
        },
        // Show only when isLive is NOT true
        ...(isLive !== 'true' ? [{
            name: 'AI Tool',
            key: 83,
            icon: 'icon-ai-encounter text-white',
            component: (
                <Suspense fallback={<Loader />}>
                    <AIPrompts />
                </Suspense>
            ),
            right: true,
            time: new Date(),
        }] : [])
        ])


]
export const HomeMenuList = () => [
    ...(isChildWindow ?
        [{
            name: 'Dashboard',
            key: 11,
            // icon: <img src={dashboard} alt={"Dashboard"+ "icon"} />,
            icon: 'bi bi-grid-fill text-white',
            component: <Suspense fallback={<Loader />}><Dashboard /></Suspense>,
            right: FindFirstChild('Home', 'Dashboard')?.ISView,
            time: new Date(),
        },]
        :
        [{
            name: 'Dashboard',
            key: 11,
            // icon: <img src={dashboard} alt={"Dashboard"+ "icon"} />,
            icon: 'bi bi-grid-fill text-white',
            component: <Suspense fallback={<Loader />}><Dashboard /></Suspense>,
            right: FindFirstChild('Home', 'Dashboard')?.ISView,
            time: new Date(),
        },
        {
            name: 'Billing Items',
            key: 14,
            // icon: <img src={billingitemicon} alt={"BilingItems"+ "icon"} />,
            icon: 'icon-Billing-Items fs-11 mt-0-5 text-white',
            component: <Suspense fallback={<Loader />}><BillingItems /></Suspense>,
            right: FindFirstChild('Home', 'Billing Items')?.ISView,
            time: new Date(),
        },
        {
            name: 'Task',
            key: 12,
            // icon: <img src={task} alt={"task"+ "icon"} />,
            icon: 'icon-TASK text-white',
            component: <Suspense fallback={<Loader />}><TaskTopLeftContent /></Suspense>,
            right: FindFirstChild('Home', 'Task')?.ISView,
            time: new Date(),
            Background: { background: "#9ACD32" },
        },
            // {
            //     name: 'Messages',
            //     key: 13,
            //     // icon: <img src={message} alt={"task"+ "icon"} />,
            //     icon: 'bi bi-chat-dots-fill text-white',
            //     component: <Suspense fallback={<Loader />}><MessageScreen /></Suspense>,
            //     right: FindFirstChild('Home', 'Messages')?.ISView,
            //     time: new Date(),
            // },
        ])

]

